import { RouteType } from '@/types/RouteType';

type ValidateRouteProps = {
  route: RouteType;
  keys: string[];
  validation?: boolean;
};

function useValidateRoutes(props: ValidateRouteProps): RouteType {
  return {
    ...props.route,
    routes: props.route.routes.filter((r) =>
      props.keys.includes(r.key) && props.validation ? false : true,
    ),
  };
}

export default useValidateRoutes;
